import script from "./Statistics.vue?vue&type=script&setup=true&lang=js"
export * from "./Statistics.vue?vue&type=script&setup=true&lang=js"

import "./Statistics.vue?vue&type=style&index=0&id=46662c84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46662c84"]])

export default __exports__